import React, { useRef, useState } from "react";

import { OutlinedButton } from "../../../components/form-controls/button/outlined-button/outlined-button.component";
import { withShowIf } from "../../../components/with-show-if/with-show-If.component";
import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import usePermissions from "../../../hooks/usePermissions";
import { VerticalGap } from "../../../components/vertical-gap/vertical-gap.component";
import { Heading } from "../../../components/headers/heading/heading.component";

import { FileUploadAttachedFiles } from "./components/file-upload-attached-files/file-upload-attached-files.component";
import { FileUploadWidgetProps } from "./file-upload-widget.props";
import { Button } from "./file-upload-widget.styles";
import { Nullable } from "../../../types/common";

export const FileUploadWidget = withShowIf((props: FileUploadWidgetProps) => {
  const userPermissions = usePermissions();

  const { accept = "*/*" } = props;

  const inputRef = useRef<Nullable<HTMLInputElement>>(null);
  const [selectedFile, setSelectedFile] = useState<File>();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmission = () => {
    if (selectedFile) {
      props.onUploadFile(selectedFile);
      inputRef!.current!.value = "";
      setSelectedFile(undefined);
    }
  };

  return (
    <BorderedBlock>
      <Heading variant="sub">Attachments</Heading>
      <FileUploadAttachedFiles
        attachedFiles={props.overviewAttachments}
        canDownload={true}
        canDelete={userPermissions.canEdit}
        removeAttachment={props.onDeleteFile}
        showIf={Boolean(props.overviewAttachments)}
      />

      <Button>
        <label className="hidden" htmlFor="files">
          Add File
        </label>
        <input id="files" accept={accept} onChange={changeHandler} ref={inputRef} type="file" />
        <VerticalGap gapInPx={32} />
        <OutlinedButton
          disabled={!selectedFile}
          onClick={handleSubmission}
          small="true"
          startIcon={props.icon}
          variant="outlined"
        >
          {props.children}
        </OutlinedButton>
      </Button>
    </BorderedBlock>
  );
});
